import React, { useState, useEffect } from 'react';
import env from "../../config/env.js";
import { verificarAcessoUsuario } from "../../utils/authStandards";
import AcessoRestrito from '../../components/AcessoRestrito';
import {
  Box,
  Autocomplete,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  IconButton,
  Tooltip,
  TableSortLabel,
  TablePagination,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  Chip,
  Snackbar,
  Alert,
  CircularProgress,
  Tabs,
  Tab,
  Switch,
  FormControlLabel
} from '@mui/material';
import {
  Add as AddIcon,
  Delete as DeleteIcon,
  Edit as EditIcon,
  Visibility as VisibilityIcon,
  Work as WorkIcon
} from "@mui/icons-material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import api from "../../services/api";






const ServicoColaborador = () => {
  // Estados principais
  const [vinculos, setVinculos] = useState([]);
  const [servicos, setServicos] = useState([]);
  const [colaboradores, setColaboradores] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [filtros, setFiltros] = useState({
    servico: "",
    colaborador: ""
  });
  const [orderBy, setOrderBy] = useState("servico");
  const [order, setOrder] = useState("asc");
  const [openForm, setOpenForm] = useState(false);
  const [openView, setOpenView] = useState(false);
  const [vinculoSelecionado, setVinculoSelecionado] = useState(null);
  const [vinculoVisualizar, setVinculoVisualizar] = useState(null);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [vinculoParaRemover, setVinculoParaRemover] = useState(null);
  const [activeTab, setActiveTab] = useState(0);
  const [formErrors, setFormErrors] = useState({
    id_servico: false,
    id_colaboradores: false
  });
  const [tentouSalvar, setTentouSalvar] = useState(false);
  const [formData, setFormData] = useState({
    id_servico: "",
    id_colaboradores: [],
    observacoes: "",
    ativo: true
  });

  const st_codHashEmpresa = localStorage.getItem("st_codHashEmpresa");
  const carregarVinculos = async () => {
    try {
      setLoading(true);
      setError(null);
      
      const res = await api.get('/servico-colaboradores');
      
      
      let lista = res.data;
      
      // Se a resposta for um array, usar diretamente
      if (Array.isArray(lista)) {
        // Não filtrar aqui - será filtrado na lógica de vinculosFiltrados
      } else {
        // Se a resposta for um objeto com propriedade data
        lista = lista.data || lista.vinculos || [];
      }
      
      setVinculos(lista);
      setSuccess(`Vínculos carregados com sucesso (${lista.length} registros)`);
    } catch (err) {
      console.error("❌ Erro ao carregar vínculos:", err);
      console.error("❌ Detalhes do erro:", {
        message: err.message,
        response: err.response?.data,
        status: err.response?.status,
        statusText: err.response?.statusText
      });
      
      setError(err.response?.data?.message || "Erro ao carregar vínculos");
      
      if (err.response?.status === 401) {
        localStorage.removeItem("token");
        localStorage.removeItem("refreshToken");
        window.location.href = "/login";
      }
    } finally {
      setLoading(false);
    }
  };

  const carregarServicos = async () => {
    try {
      const res = await api.get('/servicos', { params: { todos: true } });
      const lista = Array.isArray(res.data)
        ? res.data
        : res.data?.dados || res.data?.data || res.data?.servicos || [];
      setServicos(lista);
    } catch (err) {
      console.error("❌ Erro ao carregar serviços:", err);
      console.error("❌ Detalhes do erro:", {
        message: err.message,
        response: err.response?.data,
        status: err.response?.status,
        statusText: err.response?.statusText
      });
      setServicos([]);
    }
  };

  const carregarColaboradores = async () => {
    try {
      const res = await api.get('/colaboradores');
      
      
      let lista = res.data;
      
      if (!Array.isArray(lista)) {
        // Se a resposta for um objeto com propriedade data
        lista = lista.data || lista.colaboradores || [];
      }
      lista = lista.filter((colaborador) => colaborador.status === 'Ativo');
      
      setColaboradores(lista);
    } catch (err) {
      console.error("❌ Erro ao carregar colaboradores:", err);
      console.error("❌ Detalhes do erro:", {
        message: err.message,
        response: err.response?.data,
        status: err.response?.status,
        statusText: err.response?.statusText
      });
      setColaboradores([]);
    }
  };

  useEffect(() => {
    carregarVinculos();
    carregarServicos();
    carregarColaboradores();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    setFormErrors(prev => ({ ...prev, [name]: false }));
  };

  const limparFormulario = () => {
    setFormData({
      id_servico: "",
      id_colaboradores: [],
      observacoes: "",
      ativo: true
    });
  };

  const abrirFormulario = (vinculo = null) => {
    setVinculoSelecionado(vinculo);
    
    if (vinculo) {
      setFormData({
        id_servico: vinculo.id_servico || "",
        id_colaboradores: vinculo.id_colaborador ? [vinculo.id_colaborador] : [],
        observacoes: "",
        ativo: vinculo.ativo === undefined
          ? true
          : vinculo.ativo === true || vinculo.ativo === 1 || vinculo.ativo === '1'
      });
    } else {
      limparFormulario();
    }
    setTentouSalvar(false);
    setFormErrors({ id_servico: false, id_colaboradores: false });
    setOpenForm(true);
  };


  const fecharFormulario = () => {
    setOpenForm(false);
    setVinculoSelecionado(null);
  };

  const salvarVinculo = async () => {
    const erros = {
      id_servico: !formData.id_servico,
      id_colaboradores: formData.id_colaboradores.length === 0
    };
    setTentouSalvar(true);
    setFormErrors(erros);
    if (erros.id_servico || erros.id_colaboradores) {
      setError('Selecione o serviço e ao menos um colaborador.');
      setActiveTab(0);
      return;
    }

    const payload = {
      id_servico: formData.id_servico,
      id_colaboradores: formData.id_colaboradores,
      st_codHashEmpresa: st_codHashEmpresa,
      ativo: formData.ativo
    };

    try {
      if (vinculoSelecionado) {
        const mesmoServico = String(formData.id_servico) === String(vinculoSelecionado.id_servico);
        const mesmoColaborador = formData.id_colaboradores.length === 1 &&
          String(formData.id_colaboradores[0]) === String(vinculoSelecionado.id_colaborador);

        if (mesmoServico && mesmoColaborador) {
          await api.patch('/servico-colaboradores/ativo', {
            id_servico: vinculoSelecionado.id_servico,
            id_colaborador: vinculoSelecionado.id_colaborador,
            ativo: formData.ativo
          });
        } else {
          // Alterações de serviço ou colaborador preservam o fluxo legado de recriação.
          await api.delete('/servico-colaboradores/remover', {
            data: {
              id_servico: vinculoSelecionado.id_servico,
              id_colaborador: vinculoSelecionado.id_colaborador
            }
          });
          await api.post('/servico-colaboradores/vincular', payload);
        }
      } else {
        // Para criação: apenas cria o novo vínculo
        await api.post('/servico-colaboradores/vincular', payload);
      }
      
      carregarVinculos();
      fecharFormulario();
    } catch (error) {
      console.error("❌ Erro ao salvar vínculo:", error);
      console.error("❌ Detalhes do erro:", {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status,
        statusText: error.response?.statusText,
        headers: error.response?.headers
      });
      
      if (error.response?.data) {
        console.error("❌ Resposta completa do erro:", JSON.stringify(error.response.data, null, 2));
      }
      
      if (error.response?.status === 401) {
        localStorage.removeItem("token");
        localStorage.removeItem("refreshToken");
        window.location.href = "/login";
      } else {
        const errorMessage = error.response?.data?.message || 
                           error.response?.data?.error || 
                           error.message || 
                           "Erro desconhecido";
        alert(`Erro ao salvar vínculo: ${errorMessage}`);
      }
    }
  };

  const handleOpenConfirmDialog = (vinculo) => {
    setVinculoParaRemover(vinculo);
    setOpenConfirmDialog(true);
  };

  const handleCloseConfirmDialog = () => {
    setOpenConfirmDialog(false);
    setVinculoParaRemover(null);
  };

  const removerVinculo = async () => {
    if (!vinculoParaRemover) return;

    try {
      await api.delete('/servico-colaboradores/remover', { 
        data: { 
          id_servico: vinculoParaRemover.id_servico, 
          id_colaborador: vinculoParaRemover.id_colaborador 
        } 
      });
      
      carregarVinculos();
      handleCloseConfirmDialog();
    } catch (err) {
      console.error("❌ Erro ao excluir vínculo:", err);
      console.error("❌ Detalhes do erro:", {
        message: err.message,
        response: err.response?.data,
        status: err.response?.status
      });
      
      if (err.response?.status === 401) {
        localStorage.removeItem("token");
        localStorage.removeItem("refreshToken");
        window.location.href = "/login";
      } else {
        alert(`Erro ao excluir vínculo: ${err.response?.data?.message || err.message}`);
      }
    }
  };

  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  // O backend já aplica o tenant do usuário autenticado.
  const servicosDaEmpresa = Array.isArray(servicos) ? servicos : [];

  const idsServicosDaEmpresa = new Set(servicosDaEmpresa.map(servico => String(servico.id)));

  // Filtrar colaboradores por empresa
  const colaboradoresDaEmpresa = Array.isArray(colaboradores) ? colaboradores : [];

  const idsColaboradoresDaEmpresa = new Set(colaboradoresDaEmpresa.map(colaborador => String(colaborador.id)));

  // Debug logs removidos para limpar o console

  const vinculosFiltrados = (Array.isArray(vinculos) ? vinculos : [])
    .filter((vinculo) => {
      // Primeiro filtro: verificar se o serviço pertence à empresa
      const servicoPertenceEmpresa = idsServicosDaEmpresa.has(String(vinculo.id_servico));
      
      if (!servicoPertenceEmpresa) {
        return false;
      }

      // Segundo filtro: verificar se o colaborador pertence à empresa
      const colaboradorPertenceEmpresa = idsColaboradoresDaEmpresa.has(String(vinculo.id_colaborador));
      
      if (!colaboradorPertenceEmpresa) {
        return false;
      }

      // Terceiro filtro: aplicar filtros de busca por nome
      const servico = servicosDaEmpresa.find(s => String(s.id) === String(vinculo.id_servico));
      const colaborador = colaboradoresDaEmpresa.find(c => String(c.id) === String(vinculo.id_colaborador));
      
      const servicoMatch = !filtros.servico || 
        (servico?.nome && servico.nome.toLowerCase().includes(filtros.servico.toLowerCase()));
      
      const colaboradorMatch = !filtros.colaborador || 
        (colaborador?.nome_completo && colaborador.nome_completo.toLowerCase().includes(filtros.colaborador.toLowerCase()));
      
      return servicoMatch && colaboradorMatch;
    })
    .sort((a, b) => {
      const isAsc = order === "asc";
      const servicoA = servicosDaEmpresa.find(s => String(s.id) === String(a.id_servico));
      const servicoB = servicosDaEmpresa.find(s => String(s.id) === String(b.id_servico));
      const colaboradorA = colaboradoresDaEmpresa.find(c => String(c.id) === String(a.id_colaborador));
      const colaboradorB = colaboradoresDaEmpresa.find(c => String(c.id) === String(b.id_colaborador));
      
      if (orderBy === "servico") {
        const valA = (servicoA?.nome || "").toString().toLowerCase();
        const valB = (servicoB?.nome || "").toString().toLowerCase();
        return isAsc ? valA.localeCompare(valB) : valB.localeCompare(valA);
      } else {
        const valA = (colaboradorA?.nome_completo || "").toString().toLowerCase();
        const valB = (colaboradorB?.nome_completo || "").toString().toLowerCase();
        return isAsc ? valA.localeCompare(valB) : valB.localeCompare(valA);
      }
    });

  const handleFiltroChange = (e) => {
    const { name, value } = e.target;
    setFiltros({ ...filtros, [name]: value });
  };

  const visualizarVinculo = (vinculo) => {
    setVinculoVisualizar(vinculo);
    setActiveTab(0);
    setOpenView(true);
  };

  const fecharVisualizacao = () => {
    setOpenView(false);
    setVinculoVisualizar(null);
  };

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };


  // Verificar acesso do usuário
  if (!verificarAcessoUsuario("servicocolaborador")) {
    return <AcessoRestrito />;
  }

  return (
    <AcessoRestrito modulo="servicocolaborador">
      <Box
        sx={{
          height: '100%',
          width: '100%',
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        {/* Notificações */}
        <Snackbar 
          open={!!error} 
          autoHideDuration={env.NOTIFICATION_DURATION || 6000} 
          onClose={() => setError(null)}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
          <Alert onClose={() => setError(null)} severity="error" sx={{ width: '100%' }}>
            {error}
          </Alert>
        </Snackbar>

        <Snackbar 
          open={!!success} 
          autoHideDuration={env.NOTIFICATION_DURATION || 6000} 
          onClose={() => setSuccess(null)}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
          <Alert onClose={() => setSuccess(null)} severity="success" sx={{ width: '100%' }}>
            {success}
          </Alert>
        </Snackbar>
        
        {/* Box interno com margens de 1,5% */}
        <Box sx={{
          margin: '0 1.5% 1.5% 1.5%',  // 1,5% nas laterais e inferior
          height: '90vh',
          display: 'flex',
          flexDirection: 'column'
        }}>

          {/* Header */}
          <Box sx={{ 
            p: { xs: 2, sm: 3 }, 
            pb: 2,
            display: 'flex', 
            justifyContent: 'space-between', 
            alignItems: { xs: 'flex-start', sm: 'center' },
            flexDirection: { xs: 'column', sm: 'row' },
            gap: { xs: 2, sm: 0 }
          }}>
            <Typography 
              variant="h5" 
              mb={1} 
              sx={{ 
                fontSize: { xs: '1.5rem', sm: '2rem' },
                display: 'flex',
                alignItems: 'center',
                gap: 1
              }}
            >
              <WorkIcon sx={{ 
                fontSize: { xs: '1.5rem', sm: '2rem' },
                color: '#FFC107' // Mesma cor usada no menu lateral
              }} />
              Serviços por Colaborador
            </Typography>
            <Button 
              variant="contained" 
              onClick={() => abrirFormulario()}
              sx={{ 
                width: { xs: '100%', sm: 'auto' },
                minWidth: { xs: 'auto', sm: '200px' },
                backgroundColor: (theme) => theme.palette.mode === 'dark' 
                  ? '#ffffff' 
                  : theme.palette.primary.main,
                color: (theme) => theme.palette.mode === 'dark' 
                  ? '#000000' 
                  : theme.palette.primary.contrastText,
                '&:hover': {
                  backgroundColor: (theme) => theme.palette.mode === 'dark' 
                    ? '#f5f5f5' 
                    : theme.palette.primary.dark,
                }
              }}
            >
              <AddIcon /> Novo Vínculo
            </Button>
          </Box>

          {/* Container da Tabela */}
          <TableContainer 
            component={Paper} 
            sx={{ 
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              position: 'relative',
              overflow: 'auto',
              height: {
                xs: 'calc(90vh - 140px)',  // Mobile: mais espaço para header
                sm: 'calc(90vh - 120px)',  // Tablet: espaço padrão
                md: 'calc(90vh - 120px)',  // Desktop: espaço padrão
                lg: 'calc(90vh - 120px)'   // Large: espaço padrão
              },
              maxHeight: {
                xs: 'calc(90vh - 140px)',
                sm: 'calc(90vh - 120px)',
                md: 'calc(90vh - 120px)',
                lg: 'calc(90vh - 120px)'
              },
              width: '100%', // ✅ 100% da largura da página
              minWidth: { xs: '100%', sm: '600px' }, // ✅ 100% do mínimo também
              maxWidth: '100%', // ✅ Limita a 100% máximo
              boxShadow: (theme) => theme.palette.mode === 'dark' 
                ? '0 2px 8px rgba(0, 0, 0, 0.15)' 
                : '0 2px 8px rgba(0, 0, 0, 0.06)',
              borderRadius: 1,
              border: 'none'
            }}
          >
        {loading && (
          <Box
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: 'rgba(255, 255, 255, 0.8)',
              zIndex: 1
            }}
          >
            <CircularProgress />
          </Box>
        )}
        
        <Table sx={{ minWidth: 650, tableLayout: 'fixed' }}>
          <TableHead>
            <TableRow>
              <TableCell width="40%">
                <TableSortLabel
                  active={orderBy === "servico"}
                  direction={orderBy === "servico" ? order : "asc"}
                  onClick={() => handleRequestSort("servico")}
                >
                  Serviço
                </TableSortLabel>
                <TextField
                  name="servico"
                  size="small"
                  fullWidth
                  value={filtros.servico}
                  onChange={handleFiltroChange}
                  placeholder="Filtrar por serviço"
                />
              </TableCell>
              <TableCell width="40%">
                <TableSortLabel
                  active={orderBy === "colaborador"}
                  direction={orderBy === "colaborador" ? order : "asc"}
                  onClick={() => handleRequestSort("colaborador")}
                >
                  Colaborador
                </TableSortLabel>
                <TextField
                  name="colaborador"
                  size="small"
                  fullWidth
                  value={filtros.colaborador}
                  onChange={handleFiltroChange}
                  placeholder="Filtrar por colaborador"
                />
              </TableCell>
              <TableCell sx={{ 
                width: { xs: '20%', sm: '15%' },
                minWidth: { xs: '120px', sm: '100px' }
              }}>
                Ações
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {vinculosFiltrados.length === 0 ? (
              <TableRow>
                <TableCell colSpan={3} align="center">
                  {loading ? (
                    <CircularProgress />
                  ) : (
                    <Typography variant="body1" color="text.secondary">
                      {(Array.isArray(vinculos) ? vinculos.length : 0) === 0 
                        ? "Nenhum vínculo encontrado. Clique em 'Novo Vínculo' para começar."
                        : "Nenhum vínculo corresponde aos filtros aplicados."
                      }
                    </Typography>
                  )}
                </TableCell>
              </TableRow>
            ) : (
              vinculosFiltrados
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((vinculo) => {
                  const servico = servicosDaEmpresa.find(s => String(s.id) === String(vinculo.id_servico));
                  const colaborador = colaboradoresDaEmpresa.find(c => String(c.id) === String(vinculo.id_colaborador));
                  

                  
                  return (
                    <TableRow key={`${vinculo.id_servico}-${vinculo.id_colaborador}`}>
                      <TableCell sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        {servico?.nome || 'N/A'}
                      </TableCell>
                      <TableCell sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        {colaborador?.nome_completo || 'N/A'}
                      </TableCell>
                      <TableCell sx={{ 
                        width: { xs: '20%', sm: '15%' },
                        minWidth: { xs: '120px', sm: '100px' },
                        paddingRight: 3 // ✅ Adiciona padding à direita
                      }}>
                        <Box sx={{ 
                          display: 'flex', 
                          gap: 1,
                          justifyContent: 'flex-end' // ✅ Alinha os botões à direita
                        }}>
                          <Tooltip title="Visualizar">
                            <IconButton size="small" onClick={() => visualizarVinculo(vinculo)}>
                              <VisibilityIcon fontSize="small" className="material-icon-visibility" />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Editar">
                            <IconButton size="small" onClick={() => abrirFormulario(vinculo)}>
                              <EditIcon fontSize="small" className="material-icon-edit" />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Excluir">
                            <IconButton size="small" onClick={() => handleOpenConfirmDialog(vinculo)}>
                              <DeleteIcon fontSize="small" className="material-icon-delete" />
                            </IconButton>
                          </Tooltip>
                        </Box>
                      </TableCell>
                    </TableRow>
                  );
                })
            )}
          </TableBody>
        </Table>
      </TableContainer>
      
      {/* Paginação fora do TableContainer */}
      <TablePagination
        component="div"
        count={vinculosFiltrados.length}
        page={page}
        onPageChange={(event, newPage) => setPage(newPage)}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={(event) => {
          setRowsPerPage(parseInt(event.target.value, 10));
          setPage(0);
        }}
        rowsPerPageOptions={[5, 10, 25]}
        labelRowsPerPage="Itens por página"
        labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
        sx={{
          backgroundColor: (theme) => theme.palette.background.default,
          borderTop: 'none',
          width: '100%', // ✅ 100% da largura da página
          marginTop: 0
        }}
      />
          </Box>

        {/* Dialog de Cadastro/Edição */}
        <Dialog
          open={openForm}
          onClose={fecharFormulario}
          maxWidth={false}
          fullWidth={false}
          disableEscapeKeyDown
          disableBackdropClick
          disablePortal
          hideBackdrop={false}
          sx={{
            '& .MuiDialog-backdrop': {
              backgroundColor: 'rgba(0, 0, 0, 0.8)'
            }
          }}
          PaperProps={{
            sx: {
              width: { xs: '95vw', sm: '90vw', md: '900px' },
              height: { xs: '95vh', sm: '90vh', md: '550px' },
              maxWidth: { xs: '95vw', sm: '90vw', md: '900px' },
              maxHeight: { xs: '95vh', sm: '90vh', md: '550px' },
              position: 'relative',
              margin: { xs: 'auto', sm: 'auto', md: 'auto' }
            }
          }}
      >
          <DialogTitle sx={{ 
            backgroundColor: (theme) => theme.palette.mode === 'dark' ? '#1B5E20' : '#E0F8E0',
            borderBottom: 1,
            borderColor: 'divider',
            padding: 2,
            fontSize: '1.25rem',
            fontWeight: 500
          }}>
            {vinculoSelecionado ? "Editar Vínculo" : "Novo Vínculo"}
          </DialogTitle>
          <DialogContent sx={{ 
            height: { xs: 'calc(100% - 120px)', sm: 'calc(100% - 140px)' },
            overflow: 'auto',
            padding: { xs: 1, sm: 2 },
            '&.MuiDialogContent-root': {
              paddingTop: { xs: 1, sm: 2 }
            },
            position: 'relative',
            top: 0,
            marginBottom: { xs: '60px', sm: '60px' },
            '& .MuiInputLabel-root': {
              fontSize: { xs: '0.75rem', sm: '0.875rem' }
            },
            '& .MuiInputBase-input': {
              fontSize: { xs: '0.75rem', sm: '0.875rem' }
            },
            '& .MuiFormControlLabel-label': {
              fontSize: { xs: '0.75rem', sm: '0.875rem' }
            },
            '& .MuiTabs-root': {
              borderBottom: 1,
              borderColor: 'divider'
            },
            '& .MuiTab-root': {
              fontSize: { xs: '0.75rem', sm: '0.875rem' },
              textTransform: 'none',
              minWidth: { xs: 80, sm: 120 }
            }
          }}>
            <Tabs 
              value={activeTab} 
              onChange={handleTabChange}
              sx={{
                borderBottom: 1,
                borderColor: 'divider',
                mb: 2
              }}
            >
              <Tab label="Dados do Vínculo" />
              <Tab label="Configurações" />
            </Tabs>
            {/* Conteúdo das Abas */}
            {activeTab === 0 && (
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <Typography variant="caption" color="text.secondary">
                  * Campos obrigatórios
                </Typography>
                <Autocomplete
                  options={servicosDaEmpresa}
                  value={servicosDaEmpresa.find(
                    (servico) => String(servico.id) === String(formData.id_servico)
                  ) || null}
                  onChange={(event, servico) => {
                    setFormData((prev) => ({ ...prev, id_servico: servico?.id || '' }));
                    setFormErrors((prev) => ({ ...prev, id_servico: false }));
                  }}
                  getOptionLabel={(servico) => servico?.nome || ''}
                  isOptionEqualToValue={(option, value) => String(option.id) === String(value.id)}
                  noOptionsText="Nenhum serviço encontrado"
                  ListboxProps={{
                    sx: {
                      maxHeight: 240,
                      overflowY: servicosDaEmpresa.length > 5 ? 'auto' : 'visible'
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Serviço *"
                      required
                      error={tentouSalvar && formErrors.id_servico}
                      helperText={
                        tentouSalvar && formErrors.id_servico
                          ? 'Selecione um serviço.'
                          : 'Digite para buscar um serviço.'
                      }
                    />
                  )}
                />

                <Autocomplete
                  multiple
                  options={colaboradoresDaEmpresa}
                  value={colaboradoresDaEmpresa.filter((colaborador) =>
                    formData.id_colaboradores.some(
                      (id) => String(id) === String(colaborador.id)
                    )
                  )}
                  onChange={(event, selecionados) => {
                    setFormData((prev) => ({
                      ...prev,
                      id_colaboradores: selecionados.map((colaborador) => colaborador.id)
                    }));
                    setFormErrors((prev) => ({ ...prev, id_colaboradores: false }));
                  }}
                  getOptionLabel={(colaborador) => colaborador?.nome_completo || ''}
                  isOptionEqualToValue={(option, value) => String(option.id) === String(value.id)}
                  noOptionsText="Nenhum colaborador encontrado"
                  ListboxProps={{
                    sx: {
                      maxHeight: 240,
                      overflowY: colaboradoresDaEmpresa.length > 5 ? 'auto' : 'visible'
                    }
                  }}
                  renderTags={(selecionados, getTagProps) =>
                    selecionados.map((colaborador, index) => (
                      <Chip
                        {...getTagProps({ index })}
                        key={colaborador.id}
                        label={colaborador.nome_completo}
                        size="small"
                      />
                    ))
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Colaboradores *"
                      required
                      error={tentouSalvar && formErrors.id_colaboradores}
                      helperText={
                        tentouSalvar && formErrors.id_colaboradores
                          ? 'Selecione ao menos um colaborador.'
                          : 'Digite para buscar e selecione um ou mais colaboradores.'
                      }
                    />
                  )}
                />
              </Box>
            )}

            {activeTab === 1 && (
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <TextField
                  name="observacoes"
                  label="Observações"
                  multiline
                  rows={4}
                  value={formData.observacoes}
                  onChange={handleInputChange}
                  fullWidth
                />
                
                <FormControlLabel
                  control={
                    <Switch
                      checked={formData.ativo}
                      onChange={(e) => setFormData(prev => ({ ...prev, ativo: e.target.checked }))}
                      name="ativo"
                    />
                  }
                  label="Vínculo Ativo"
                />
              </Box>
            )}
        </DialogContent>
        <DialogActions sx={{ 
          position: 'absolute',
          bottom: 0,
          left: 0,
          right: 0,
          padding: 2,
          backgroundColor: (theme) => theme.palette.mode === 'dark' ? '#1B5E20' : '#E0F8E0',
          borderTop: 1,
          borderColor: 'divider',
          zIndex: 1,
          height: '60px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <Typography variant="body2" color="text.secondary">
            {new Date().toLocaleString('pt-BR', {
              day: '2-digit',
              month: '2-digit',
              year: 'numeric',
              hour: '2-digit',
              minute: '2-digit'
            })}
          </Typography>
          <Box>
            <Button 
              variant="contained" 
              color="primary"
              onClick={fecharFormulario}
            >
              FECHAR
            </Button>
            <Button 
              variant="contained" 
              color="primary"
              onClick={salvarVinculo}
              disabled={loading}
            >
              {loading ? <CircularProgress size={20} /> : "SALVAR"}
            </Button>
          </Box>
        </DialogActions>
      </Dialog>

        {/* Dialog de Visualização */}
        <Dialog
          open={openView}
          onClose={fecharVisualizacao}
          maxWidth={false}
          fullWidth={false}
          disableEscapeKeyDown
          disableBackdropClick
          disablePortal
          hideBackdrop={false}
          sx={{
            '& .MuiDialog-backdrop': {
              backgroundColor: 'rgba(0, 0, 0, 0.8)'
            }
          }}
          PaperProps={{
            sx: {
              width: { xs: '95vw', sm: '90vw', md: '900px' },
              height: { xs: '95vh', sm: '90vh', md: '550px' },
              maxWidth: { xs: '95vw', sm: '90vw', md: '900px' },
              maxHeight: { xs: '95vh', sm: '90vh', md: '550px' },
              position: 'relative',
              margin: { xs: 'auto', sm: 'auto', md: 'auto' }
            }
          }}
      >
          <DialogTitle sx={{ 
            backgroundColor: (theme) => theme.palette.mode === 'dark' ? '#1B5E20' : '#E0F8E0',
            borderBottom: 1,
            borderColor: 'divider',
            padding: 2,
            fontSize: '1.25rem',
            fontWeight: 500
          }}>
            Visualizar Vínculo
          </DialogTitle>
          <DialogContent sx={{ 
            height: { xs: 'calc(100% - 120px)', sm: 'calc(100% - 140px)' },
            overflow: 'auto',
            padding: { xs: 1, sm: 2 },
            '&.MuiDialogContent-root': {
              paddingTop: { xs: 1, sm: 2 }
            },
            position: 'relative',
            top: 0,
            marginBottom: { xs: '60px', sm: '60px' },
          '& .MuiInputLabel-root': {
            fontSize: '0.875rem'
          },
          '& .MuiInputBase-input': {
            fontSize: '0.875rem'
          },
          '& .MuiFormControlLabel-label': {
            fontSize: '0.875rem'
          },
          '& .MuiTabs-root': {
            borderBottom: 1,
            borderColor: 'divider'
          },
          '& .MuiTab-root': {
            fontSize: { xs: '0.75rem', sm: '0.875rem' },
            textTransform: 'none',
            minWidth: { xs: 80, sm: 120 }
          }
        }}>
          <Tabs 
            value={activeTab} 
            onChange={handleTabChange}
            sx={{
              borderBottom: 1,
              borderColor: 'divider',
              mb: 2
            }}
          >
            <Tab label="Dados do Vínculo" />
            <Tab label="Configurações" />
          </Tabs>
          
          {/* Conteúdo das Abas */}
          {activeTab === 0 && (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <TextField
              label="Serviço"
              value={(() => {
                const servico = servicosDaEmpresa.find(s => String(s.id) === String(vinculoVisualizar?.id_servico));
                return servico?.nome || 'N/A';
              })()}
              fullWidth
              disabled
              inputProps={{
                sx: { backgroundColor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.05)' }
              }}
            />
              <TextField
                label="Colaboradores"
                value={(() => {
                  const idsVinculados = vinculoVisualizar?.id_colaboradores ||
                    (vinculoVisualizar?.id_colaborador ? [vinculoVisualizar.id_colaborador] : []);
                  const colaboradoresVinculados = colaboradoresDaEmpresa.filter(c =>
                    idsVinculados.some(id => String(id) === String(c.id))
                  );
                  return colaboradoresVinculados.map(c => c.nome_completo).join(', ') || 'N/A';
                })()}
                fullWidth
                multiline
                rows={3}
                disabled
                inputProps={{
                  sx: { backgroundColor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.05)' }
                }}
              />
            </Box>
          )}

          {activeTab === 1 && (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <TextField
                label="Observações"
                value={vinculoVisualizar?.observacoes || 'N/A'}
                fullWidth
                multiline
                rows={4}
                disabled
                inputProps={{
                  sx: { backgroundColor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.05)' }
                }}
              />
              
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Typography variant="body2">Status:</Typography>
                {vinculoVisualizar?.ativo ? (
                  <Chip 
                    icon={<CheckCircleIcon />} 
                    label="Ativo" 
                    color="success" 
                    size="small" 
                  />
                ) : (
                  <Chip 
                    icon={<CancelIcon />} 
                    label="Inativo" 
                    color="error" 
                    size="small" 
                  />
                )}
              </Box>
            </Box>
          )}
        </DialogContent>
        <DialogActions sx={{ 
          position: 'absolute',
          bottom: 0,
          left: 0,
          right: 0,
          padding: 2,
          backgroundColor: (theme) => theme.palette.mode === 'dark' ? '#1B5E20' : '#E0F8E0',
          borderTop: 1,
          borderColor: 'divider',
          zIndex: 1,
          height: '60px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <Typography variant="body2" color="text.secondary">
            {new Date().toLocaleString('pt-BR', {
              day: '2-digit',
              month: '2-digit',
              year: 'numeric',
              hour: '2-digit',
              minute: '2-digit'
            })}
          </Typography>
          <Box>
            <Button 
              variant="contained" 
              color="primary"
              onClick={fecharVisualizacao}
              sx={{ 
                textTransform: 'uppercase',
                fontSize: '0.875rem',
                fontWeight: 500
              }}
            >
              FECHAR
            </Button>
          </Box>
        </DialogActions>
      </Dialog>

        {/* Diálogo de Confirmação */}
        <Dialog 
          open={openConfirmDialog} 
          onClose={handleCloseConfirmDialog}
          maxWidth="xs" 
          fullWidth
        >
          <DialogTitle sx={{ 
            backgroundColor: (theme) => theme.palette.mode === 'dark' ? '#1B5E20' : '#E0F8E0',
            borderBottom: 1,
            borderColor: 'divider',
            padding: 2,
            fontSize: '1.25rem',
            fontWeight: 500
          }}>
            Confirmar Exclusão
          </DialogTitle>
        <DialogContent sx={{ padding: 2 }}>
          <DialogContentText>
            Tem certeza que deseja excluir este vínculo?
          </DialogContentText>
        </DialogContent>
          <DialogActions sx={{ 
            backgroundColor: (theme) => theme.palette.mode === 'dark' ? '#1B5E20' : '#E0F8E0',
            borderTop: 1,
            borderColor: 'divider',
            padding: 2
          }}>
            <Button 
              onClick={handleCloseConfirmDialog}
              sx={{ 
                textTransform: 'uppercase',
                fontSize: '0.875rem',
                fontWeight: 500
              }}
            >
              Cancelar
            </Button>
            <Button
              onClick={removerVinculo}
              color="error"
              variant="contained"
              sx={{ 
                textTransform: 'uppercase',
                fontSize: '0.875rem',
                fontWeight: 500
              }}
            >
              Excluir
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
    </AcessoRestrito>
  );
};

export default ServicoColaborador;
